import { tWithKeyAttr as t } from "../../i18nHelper";
import React, { useState } from "react";
import Tooltip from "../tooltip/tooltip";
import i18n from "../../i18n";

interface Props {
  isActive: boolean;
  onToggle: () => void;
  isLoading?: boolean;
}

const StatusSwitchToggle: React.FC<Props> = ({ isActive, onToggle, isLoading }) => {
  const [isHovered, setIsHovered] = useState(false);
  const tooltipPosition = i18n.language === 'he' ? 'left' : 'right';

  return (
    <div
      style={{
        position: "relative",
        display: "inline-block",
        overflow: "visible",
      }}
    >
      <Tooltip isShown={isHovered} position={tooltipPosition} variant="toggle">
        {isActive ? t('TURN_INACTIVE') : t('BECOME_ACTIVE')}
      </Tooltip>

      <div
        onClick={() => {
          if (!isLoading) onToggle();
        }}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        style={{
          width: 50,
          height: 24,
          borderRadius: 9999,
          backgroundColor: isActive
            ? isHovered
              ? "#0d80e4ff"
              : "#006cc9"
            : isHovered
            ? "#db0000ff"
            : "#ff0000ff",
          // border: isActive ? "none" : "1px solid #ff0000",
          position: "relative",
          cursor: isLoading ? "not-allowed" : "pointer",
          opacity: isLoading ? 0.6 : 1,
          transition: "background-color 0.3s ease, border 0.3s ease",
        }}
      >
        <div
          style={{
            width: isHovered ? 18 : 16,
            height: isHovered ? 18 : 16,
            backgroundColor: "white",
            borderRadius: "50%",
            position: "absolute",
            top: isHovered ? 3 : 4,
            left: isActive ? (isHovered ? 29 : 30) : isHovered ? 3 : 4,
            transition:
              "left 0.3s ease, background-color 0.3s ease, width 0.2s ease, height 0.2s ease, top 0.2s ease",
            boxShadow: "0 0 3px rgba(0,0,0,0.3)",
          }}
        />
      </div>
    </div>
  );
};

export default StatusSwitchToggle;
